import { Component, OnInit } from '@angular/core';
import { TrisTicket } from '@app/@shared/models/tris.model';
import { TrisService } from '@app/@shared/services/tris.service';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-tris-multiplicador',
  templateUrl: './tris-multiplicador.component.html',
  styleUrl: './tris-multiplicador.component.scss',
})
export class TrisMultiplicadorComponent implements OnInit {
  min = 0;
  max = 0;
  quantity = 0;
  prize = 0;
  prizeMultiplicador = 0;
  ticket!: TrisTicket;
  trisS!: TrisService;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit(): void {
    this.quantity = this.ticket.multiplicadorAmount;
    this.max = this.trisS.calculateMax(this.ticket, true) / (this.ticket.price.code === 'pack10' ? 2 : 1);
    this.calculatePrizes();
  }

  calculatePrizes() {
    const ticket = { ...this.ticket };
    ticket.multiplicadorAmount = this.quantity;
    this.prize = this.trisS.calculatePrize(ticket, 'cost');
    this.prizeMultiplicador = this.trisS.calculatePrize(ticket, 'multiplier');
  }

  send() {
    this.modalCtrl.dismiss(
      {
        quantity: this.quantity,
      },
      'save'
    );
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
